import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { Utils } from '@src/utils/util';
import { ProcessesHoverViewComponent} from './processesHoverView'
import {HttpClientModule} from '@angular/common/http';

@NgModule({
    imports: [SharedModule, HttpClientModule ],
    declarations: [ProcessesHoverViewComponent],
    entryComponents: [ProcessesHoverViewComponent],
    exports: [ProcessesHoverViewComponent],
    providers: [ Utils]
})

export class processesHoverViewModule{}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/pipeline/processesHoverView-ang7/processesHoverView.module.ts